const normaliseSearchValue = (value) => String(value || "").toLowerCase().trim()

const getClientName = (client = {}) => `${client.first_name || ""} ${client.last_name || ""}`.trim()

export const enquiryMatchesSearch = (enquiry, client, searchTerm) => {
	const query = normaliseSearchValue(searchTerm)
	if (!query) return true

	const clientData = client || {}
	const textValues = [
		enquiry.id,
		enquiry.site,
		enquiry.location,
		enquiry.group_size,
		enquiry.quoted,
		enquiry.status,
		getClientName(clientData),
		clientData.email || enquiry.email,
		clientData.phone || enquiry.phone,
		clientData.company,
		...(enquiry.tags || []),
	]

	const searchableText = textValues
		.filter((value) => value || value === 0)
		.map((value) => String(value).toLowerCase())
		.join(" ")

	if (searchableText.includes(query)) return true

	const queryDigits = query.replace(/\D/g, "")
	if (!queryDigits) return false

	const searchableDigits = textValues
		.filter((value) => value || value === 0)
		.map((value) => String(value).replace(/\D/g, ""))
		.join(" ")

	return searchableDigits.includes(queryDigits)
}
